/**
 * Tipos del módulo Manifiestos (API)
 */

export interface ManifiestoCarrierOption {
  id: string
  label: string
  transportadora: string
}

export type ManifiestoCaso = 'sin_manifiesto' | 'cerrado' | 'abierto'

export type ManifiestoEstado =
  | 'Creado'
  | 'En verificación'
  | 'Listo para imprimir'
  | 'Impreso'
  | 'Cerrado'
  | string

export interface ManifiestoUsuario {
  id: number
  nombre: string
  apellido: string
}

export interface ManifiestoPedidoLinea {
  id?: number
  id_pedido: number
  numero_pedido?: string | number
  estado?: string
  guia?: string
  /** Paquetes ya escaneados en la app */
  paquetes_verificados?: number
  /** Total de cajas del pedido */
  unidades_empaque?: number
  fecha_asignacion?: string | null
  fecha_ultima_verificacion?: string | null
  fecha_eliminacion?: string | null
  id_usuario_eliminacion?: number | null
}

export interface Manifiesto {
  id: number
  estado: ManifiestoEstado
  transportadora?: string
  consecutivo?: string
  fechaCreacion?: string
  fechaModificacion?: string
  fechaInicioVerificacion?: string | null
  creadoPor?: ManifiestoUsuario | null
  verificadoPor?: ManifiestoUsuario | null
  cerradoPor?: ManifiestoUsuario | null
  pedidos?: ManifiestoPedidoLinea[]
}

export interface ManifiestoActivoData {
  caso: ManifiestoCaso
  manifiesto?: Manifiesto | null
}

export interface ManifiestoDespachoRow {
  index: number
  numeroVisible: string
  orderId: number
  destinatario: string
  ciudad: string
  direccion: string
  contenido: string
  documento: string
  und: number
  peso: number
  vol: number
  decl: number
  declLabel: string
  flete: number
  fleteLabel: string
  guia: string
  ciudadCentro: string
}

export const MANIFIESTO_ESTADO_CREADO = 'Creado'
export const MANIFIESTO_ESTADO_LISTO = 'Listo para imprimir'
export const MANIFIESTO_ESTADO_IMPRESO = 'Impreso'
export const MANIFIESTO_LINEA_ACTIVA = 'Activo'
